import { useEffect, useState } from "react";
import { AiFillBackward, AiFillCheckCircle } from "react-icons/ai";
import { CiCircleRemove } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import { useGetProductQuery } from "../../features/api/productApi";
import NewDealer from "./NewDealer";
import {
  useBothSalesItemsQuery,
  useGetInvoicesQuery,
} from "../../features/api/orderinvoiceApi";
import {
  useAddChallanMutation,
  useGetChallanByChNoQuery,
} from "../../features/api/challan2Api";
import { useGetSubCategoryQuery } from "../../features/api/subcategoryApi";
import { getuser } from "../../components/CommonDateFormat";
import { useGetSubjectsQuery } from "../../features/api/subjectApi";
import CreateSubject from "../CategoryManagement/Subjects/CreateSubject";
import SearchableSelect from "../../components/SearchableSelect";
import { useGetAllModelQuery } from "../../features/api/modelApi";
import { FaPlus } from "react-icons/fa";

const CreateChallan = () => {
  const user = getuser();

  const [invId, setInvoice] = useState("");
  const [dealer, setDealerName] = useState("");
  const [ch_ref, setReference] = useState("");
  const [ch_sub, setSubject] = useState(6);
  const [subCatId, setSubCatId] = useState(1);
  const [proId, setProId] = useState("");
  const [modelId, setModelId] = useState("");
  const [insertId, setInsertId] = useState("");

  const subCategory = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const findProduct = products?.find((item) => item?.id == proId)?.product_name;

  const productModels = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;
  const findModel = productModels?.find((item) => item?.model_id == modelId);

  const subjects = useGetSubjectsQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.supplier;

  const [chno, setChNo] = useState("");

  const existChallan = useGetChallanByChNoQuery(chno, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const dealers = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.dealer;

  // fetch all orders2 for create chalan number
  const invoices = useGetInvoicesQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data;
  const filterInvoiceByDealer = invoices?.filter(
    (inv) => inv?.dealer == dealer
  );

  const bothSales = useBothSalesItemsQuery(invId, {
    refetchOnMountOrArgChange: true,
  });
  const master = bothSales?.data?.master;
  const items = bothSales?.data?.data;

  const [ch_date, setChDate] = useState("");
  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setChDate(currentDate);
  }, []);

  const [newArray, setNewArray] = useState([]);

  const handleSave = (data) => {
    console.log(data);
    setNewArray([
      ...newArray,
      {
        ch_date: ch_date,
        dealer: dealer,
        pro_name: data?.product,
        model_id: data?.model_id,
        modelName: data?.model,
        qty: 1,
        rmks: "",
        unit_rate: data?.sales_rate,
        total: data?.total,
      },
    ]);
  };

  const handleAddItem = () => {
    setNewArray([
      ...newArray,
      {
        ch_date: ch_date,
        dealer: dealer,
        pro_name: findProduct,
        model_id: findModel?.model_id,
        modelName: findModel?.model_name,
        qty: Number(1),
        rmks: "",
        unit_rate: Number(0),
        total: Number(0),
      },
    ]);
  };

  const handleRemove = (data) => {
    const restProduct = newArray?.filter(
      (item) => item?.model_id !== data?.model_id
    );
    setNewArray(restProduct);
  };

  // handle description for individual product
  const handleDescChange = (index, desc) => {
    const updatedData = [...newArray];
    updatedData[index].rmks = desc;
    setNewArray(updatedData);
  };

  // handle quantity for individual product
  const handleQuantityChange = (index, qty) => {
    const updatedData = [...newArray];
    updatedData[index].qty = qty;
    updatedData[index].total = qty * updatedData[index].unit_rate;
    setNewArray(updatedData);
  };

  const subTotal = newArray?.reduce((sum, item) => sum + item.total, 0);

  const navigate = useNavigate();

  const [addChallan] = useAddChallanMutation();
  const [loading, setLoading] = useState(false);
  const handleChallan = async () => {
    setLoading(true);

    try {
      const response = await addChallan({
        inv_id: invId,
        ch_no: chno,
        ch_date: ch_date,
        dealer: dealer,
        ch_sub: ch_sub,
        ch_ref: ch_ref,
        total: subTotal,
        created_by: user?.id,
        items: newArray,
      });
      if (response?.data) {
        setInsertId(response?.data?.insertId);
        setLoading(false);
        // navigate("/dashboard/challan");
        toast.success("Challan created successfully");
      } else if (response?.error) {
        setLoading(false);
        toast.error(response?.error?.data?.error);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error creating data:", error?.response);
    }
  };

  useEffect(() => {
    if (insertId) {
      navigate(`/dashboard/challan/report/${insertId}`);
    }
  }, [insertId]);

  return (
    <div className="h-full lg:h-[90vh] overflow-auto bg-slate-200">
      <div className="flex justify-between items-center p-4">
        <h1 className="text-xl font-bold">Create Challan</h1>

        <div className="flex items-center gap-x-2">
          <CreateSubject />
          <NewDealer />
          <Link
            to="/dashboard/challan"
            className="bg-blue-500 px-2 py-1 rounded text-white flex items-center gap-x-1"
          >
            <AiFillBackward /> Challan List{" "}
          </Link>
        </div>
      </div>
      <div className="">
        <div className="p-4 m-4 border">
          <div className="flex flex-col gap-1 w-[max-content] mb-4">
            <label className="font-bold">Hospital Name</label>
            <select
              onChange={(e) => setDealerName(e.target.value)}
              className="border h-8 p-1 bg-slate-50"
            >
              <option value={(e) => setDealerName(e.target.value)}>
                --select--
              </option>
              {dealers?.map((dealer) => (
                <option key={dealer?.id} value={dealer?.id} className="">
                  {dealer?.d_name} - {dealer?.d_mobile}
                </option>
              ))}
            </select>
          </div>
          <form className=" grid grid-cols-1 lg:grid-cols-5 gap-2">
            <div className="flex flex-col gap-1">
              <label className="font-bold">Invoice</label>
              <select
                onChange={(e) => setInvoice(e.target.value)}
                className="border h-8 p-1 bg-slate-50"
              >
                <option>--select--</option>
                {filterInvoiceByDealer?.map((inv) => (
                  <option key={inv?.id} value={inv?.id} className="">
                    {inv?.inv_no}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold">Invoice Date</label>

              <input
                type="date"
                value={master?.inv_date}
                disabled
                className="border h-8 pl-1 bg-slate-50"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold">Delivery Date</label>
              <input
                type="date"
                value={master?.d_date}
                disabled
                className="border h-8 pl-1 bg-slate-50"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="font-bold">Challan No.</label>
              <input
                type="text"
                value={chno}
                onChange={(e) => setChNo(e.target.value)}
                className="border h-8 pl-1 bg-slate-50"
              />
              {existChallan?.length > 0 && (
                <p className="text-sm font-medium text-red-500">
                  Challan No. already exist
                </p>
              )}
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold">Challan Date</label>

              <input
                type="date"
                value={ch_date}
                onChange={(e) => setChDate(e.target.value)}
                className="border h-8 pl-1 bg-slate-50"
              />
            </div>
          </form>
          <div className="grid grid-cols-1 md:grid-cols-4 md:gap-4 my-3">
            <div className="flex flex-col gap-1">
              <label className="font-medium">Brand</label>
              <select
                value={subCatId}
                onChange={(e) => setSubCatId(Number(e.target.value))}
                className="border border-slate-300 rounded-sm h-8 pl-1"
              >
                {subCategory?.map((sCat) => (
                  <option key={sCat?.id} value={sCat?.id}>
                    {sCat?.sub_catName}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-medium">Product / Spare Parts</label>

              <SearchableSelect
                options={[
                  { value: "", label: "--select--" },
                  ...(products?.map((i) => ({
                    value: i?.id,
                    label: i?.product_name,
                  })) || []),
                ]}
                value={proId}
                onChange={(e) => setProId(Number(e.target.value))}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-medium">Machine Models</label>

              <SearchableSelect
                options={[
                  { value: "", label: "--select--" },
                  ...(productModels
                    ?.filter((model) => model.product_id === +proId)
                    .map((i) => ({
                      value: i?.model_id,
                      label: i?.model_name,
                    })) || []),
                ]}
                value={modelId}
                onChange={(e) => setModelId(Number(e.target.value))}
              />
            </div>
          </div>
          <button
            onClick={() => handleAddItem()}
            className="bg-white border border-black px-4 py-1   font-bold flex items-center gap-1 mx-auto mt-4"
          >
            <FaPlus size={14} /> <span>Add</span>
          </button>
          <p className="mt-8 mb-2 font-bold text-center text-xl">
            Invoice Information{" "}
          </p>
          {items?.length > 0 && (
            <table className="min-w-full  bg-[#ffcccc]">
              <thead>
                <tr>
                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Brand
                  </th>
                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Product
                  </th>
                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Quantity
                  </th>
                  <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {items?.map((data, index) => {
                  const exist = newArray?.find(
                    (d) => d?.model_id == data?.model_id
                  );
                  return (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        {data?.brand}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        {data?.product}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        {data?.qty}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        {!exist && (
                          <div
                            onClick={() => handleSave(data)}
                            className="flex items-center gap-x-2 justify-center cursor-pointer"
                          >
                            <button className="text-xl bg-green-500 rounded-full">
                              <AiFillCheckCircle />
                            </button>
                            <span>Click for challan entry</span>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        {newArray?.length > 0 && (
          <div className="p-4 m-4 border ">
            <p className="text-center font-bold">Create Challan</p>
            <div className="mb-4">
              <div className="flex flex-col gap-1">
                <label className="font-bold">Subject</label>
                <select
                  value={ch_sub}
                  onChange={(e) => setSubject(Number(e.target.value))}
                  className="border h-8 p-1 bg-slate-50"
                >
                  <option value={""}>--select--</option>
                  {subjects?.map((subject) => (
                    <option key={subject?.id} value={subject?.id} className="">
                      {subject?.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col gap-1">
                <label className="font-bold">Reference</label>
                <textarea
                  onChange={(e) => setReference(e.target.value)}
                  rows={2}
                  className="focus:outline-none p-1 border bg-slate-50"
                />
              </div>
            </div>

            <p className="font-bold mb-2">{master?.model_srl}</p>

            <table
              className="min-w-full bg-white "
              style={{ backgroundColor: "#f0f0f5" }}
            >
              <thead>
                <tr>
                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Product / Spare Parts
                  </th>

                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Machine Model
                  </th>

                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                    Description
                  </th>

                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Quantity
                  </th>
                  {/* <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Rate
                  </th>
                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Total Amount
                  </th> */}
                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {newArray?.map((data, index) => {
                  console.log(data);

                  return (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        {data?.pro_name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        {data?.modelName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        <textarea
                          onChange={(e) =>
                            handleDescChange(index, e.target.value)
                          }
                          className="border focus:outline-none text-sm h-12 "
                        />
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        <input
                          onChange={(e) =>
                            handleQuantityChange(index, Number(e.target.value))
                          }
                          type="text"
                          defaultValue={data?.qty}
                          className="border pl-1 w-16 focus:outline-none bg-slate-50"
                        />
                      </td>
                      {/* <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        {data?.unit_rate}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        {data?.total}
                      </td> */}
                      <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                        <button
                          onClick={() => handleRemove(data)}
                          className="text-xl text-white bg-red-500 rounded-full"
                        >
                          <CiCircleRemove />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <button
              onClick={() => handleChallan()}
              className={`bg-green-500 px-4 py-1 text-white font-bold  mt-4 `}
            >
              {loading ? "Loading..." : "Submit"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateChallan;
